module.exports = __webpack_public_path__ + "static/media/p5.c8345137.ogg";